import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_DMX_UNIVERSES_BY_CONTROLLER } from './actionTypes';
import { getDmxUniversesByControllerSuccess, getDmxUniversesByControllerError } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* getUniversesByController({ payload: { user, controllerId } }) {
  try {
    const response = yield call(dmxAPI.getUniversesByController, user.token, controllerId);
    yield put(getDmxUniversesByControllerSuccess(response));
  } catch (error) {
    yield put(getDmxUniversesByControllerError(error));
  }
}

export function* watchGetDmxUniversesByController() {
  yield takeEvery(GET_DMX_UNIVERSES_BY_CONTROLLER, getUniversesByController);
}

function* getDmxUniversesByControllerSaga() {
  yield all([fork(watchGetDmxUniversesByController)]);
}

export default getDmxUniversesByControllerSaga;
